import type { AccountDict } from '../en/account';

export const account: AccountDict = {
  menu: 'Kontoinställningar',
  title: 'Kontoinställningar',
  subtitle: 'Ditt namn, lösenord och språk.',
  profile: {
    title: 'Profil',
    firstName: 'Förnamn',
    lastName: 'Efternamn',
    email: 'E-post',
    emailHint: 'Kontakta din administratör för att ändra e-postadress.',
    organization: 'Organisation',
    save: 'Spara',
    saved: 'Profilen sparades',
  },
  password: {
    title: 'Lösenord',
    current: 'Nuvarande lösenord',
    next: 'Nytt lösenord',
    confirm: 'Upprepa det nya lösenordet',
    hint: 'Minst 8 tecken.',
    mismatch: 'De nya lösenorden stämmer inte överens',
    wrongCurrent: 'Det nuvarande lösenordet stämmer inte',
    save: 'Byt lösenord',
    saved: 'Lösenordet byttes',
  },
  language: {
    title: 'Språk',
    hint: 'Används för appen på den här enheten.',
  },
  failed: 'Kunde inte spara',
};
